import React from 'react';
import type { Edge } from './types';
import { LabeledSelect } from './Fields';

interface Props {
  stepIds: string[];
  edges: Edge[];
  edgeFrom: string;
  edgeTo: string;
  onChangeEdgeFrom: (value: string) => void;
  onChangeEdgeTo: (value: string) => void;
  onAddEdge: () => void;
  onRemoveEdge: (edgeId: string) => void;
}

export default function EdgesCard({
  stepIds,
  edges,
  edgeFrom,
  edgeTo,
  onChangeEdgeFrom,
  onChangeEdgeTo,
  onAddEdge,
  onRemoveEdge,
}: Props) {
  const options = [{ value: '', label: '—' }, ...stepIds.map((s) => ({ value: s, label: s }))];

  return (
    <div className="pac-glass rounded-md p-3 space-y-3">
      <h4 className="text-sm font-semibold text-neutral-200">Edges</h4>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
        <LabeledSelect label="From" value={edgeFrom} options={options} onChange={onChangeEdgeFrom} />
        <LabeledSelect label="To" value={edgeTo} options={options} onChange={onChangeEdgeTo} />
        <div className="flex items-end">
          <button
            className="w-full px-3 py-1 rounded border border-neutral-700 text-neutral-200 hover:border-neutral-500"
            onClick={onAddEdge}
          >
            Add
          </button>
        </div>
      </div>

      {edges.length > 0 && (
        <div className="space-y-2">
          {edges.map((e) => (
            <div key={e.id} className="flex items-center justify-between text-xs text-neutral-300">
              <span className="truncate">{e.from} → {e.to}</span>
              <button className="text-rose-400 hover:text-rose-300" onClick={() => onRemoveEdge(e.id)}>Remove</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
